import { isNil } from 'lodash';
import WForbiddenCommandKeywordLegend from '@/components/button/ForbiddenCommandKeywordLegend';

/**
 * 금지 수행 명령어 적용을 위한 mixin
 * @type {Object}
 */
export default {
  components: {
    WForbiddenCommandKeywordLegend,
  },
  methods: {
    /**
     * 금지 수행 명령어이 있는지 여부를 체크 후 금지 명령어가 있으면 수행을 중지한다.
     * @param  {object} forbiddenCommandList   [금지 수행 명령어 목록]
     * @param  {string} scriptContents [체크할 스크립트 문구]
     */
    checkForbiddenCommand(forbiddenCommandList, scriptContents) {
      let checkForbiddenCommandMessage = null;
      forbiddenCommandList.forEach((command) => {
        let matcher = null;
        if (/[`~!@#$%^&*|\\\'\";:\/?-]/gm.test(command.basicinfoSubname)) {
          matcher = new RegExp(command.basicinfoSubname, 'gm');
        } else {
          matcher = new RegExp(`([\\s|\\r|\\n]${command.basicinfoSubname}[\\s|\\r|\\n])|(^${command.basicinfoSubname}[\\s|\\r|\\n])|([\\s|\\r|\\n]${command.basicinfoSubname}$)|(^${command.basicinfoSubname}$)`, 'gm');
        }
        if (matcher.test(scriptContents)) {
          if (isNil(checkForbiddenCommandMessage)) {
            checkForbiddenCommandMessage = command.basicinfoSubname;
          } else {
            checkForbiddenCommandMessage = `${checkForbiddenCommandMessage}, ${command.basicinfoSubname}`;
          }
        }
      });
      if (!isNil(checkForbiddenCommandMessage)) {
        this.$message({
          dangerouslyUseHTMLString: true,
          type: 'error',
          message: `수행 불가능한 명령어가 포함되어있습니다.</br></br>(${checkForbiddenCommandMessage})`,
        });
        return true;
      }
      return false;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/forbidden-command-script.js